import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Delete, Download } from '@tds/core-interactive-icon';
import Spinner from '@tds/core-spinner';

import Confirmation from './confirmation';
import request, { apiHost } from '../../../../../../../../utils/request';

const FilesListRow = ({ fileData, removeFileFromList, orderId }) => {
  const { filename, fileId } = fileData;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const onDeleteFile = async () => {
    try {
      setConfirmDelete(false);
      setIsDeleting(true);
      const result = await request.delete(
        `/orders/${orderId}/delete-file/${fileId}`
      );
      if (result) {
        setIsDeleting(false);
        removeFileFromList(fileId);
      }
    } catch (error) {
      setIsDeleting(false);
      throw error;
    }
  };

  const onFileDownload = () => {
    window.open(`${apiHost}/orders/${orderId}/file/${fileId}`, '_blank');
  };

  return (
    <>
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {confirmDelete && (
          <Confirmation
            setConfirmDelete={setConfirmDelete}
            onDeleteFile={onDeleteFile}
            fileName={filename}
          />
        )}
        {!confirmDelete && (
          <Spinner label="" spinning={isDeleting} inline>
            <div>{filename}</div>
            <div>
              <Download onClick={onFileDownload} a11yText="Download" />
              <span style={{ margin: '0 0.5rem' }}></span>
              <Delete
                onClick={() => setConfirmDelete(true)}
                a11yText="Delete"
              />
            </div>
          </Spinner>
        )}
      </li>
    </>
  );
};

FilesListRow.propTypes = {
  fileData: PropTypes.arrayOf(PropTypes.any).isRequired,
  removeFileFromList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FilesListRow;
